"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMediaImageUrlAndSizeObject = exports.getStock = exports.buildMediaItemFromIMedia = exports.variantMapper = void 0;
var defenitions_1 = require("../defenitions");
var mappers_1 = require("../products/mappers");
exports.variantMapper = function (variantDTO) {
    var mediaItem = variantDTO.media ? mappers_1.buildImageUrl(exports.buildMediaItemFromIMedia(variantDTO.media)) : mappers_1.buildImageUrl(null);
    return {
        _id: variantDTO.id,
        variantId: variantDTO.variantId,
        productId: variantDTO.productId,
        variantName: variantDTO.variantName,
        productName: variantDTO.productName,
        fullVariantName: createFullVariantName(variantDTO.variantId, variantDTO.variantName, variantDTO.productName),
        managedVariant: !!variantDTO.managedVariant,
        sku: variantDTO.sku,
        stock: exports.getStock(variantDTO.stock),
        choices: variantDTO.choices,
        media: mediaItem,
        collections: variantDTO.collections,
    };
};
var VARIANT_ID_OF_NON_VARIANT_PRODUCT = '00000000-0000-0000-0000-000000000000';
var createFullVariantName = function (variantId, variantName, productName) {
    return variantId === VARIANT_ID_OF_NON_VARIANT_PRODUCT ? productName : productName + " - " + variantName;
};
exports.buildMediaItemFromIMedia = function (media) {
    return {
        id: media.image ? media.image.id : media.video.id,
        thumbnail: media.image
            ? exports.getMediaImageUrlAndSizeObject(media.image)
            : exports.getMediaImageUrlAndSizeObject(media.video.resolutions),
        mediaType: media.image ? defenitions_1.MediaItemType.image : defenitions_1.MediaItemType.video,
        title: '',
        image: media.image ? exports.getMediaImageUrlAndSizeObject(media.image) : undefined,
        video: {
            files: media.video ? [exports.getMediaImageUrlAndSizeObject(media.video.resolutions)] : [],
        },
    };
};
exports.getStock = function (stock) {
    var trackQuantity = !!stock.trackQuantity;
    return {
        trackQuantity: trackQuantity,
        quantity: stock.quantity,
        inStock: stock.inStock,
    };
};
exports.getMediaImageUrlAndSizeObject = function (item) {
    return {
        url: item.url,
        width: item.width,
        height: item.height,
    };
};
//# sourceMappingURL=variants.mapper.js.map